import { cardinalityKeyOf, cardinalityLabels, TagCategory } from 'apprise-core/category'
import { utils } from 'apprise-core/utils'
import { useT } from 'apprise-frontend-core/intl/language'
import { useL } from 'apprise-frontend-core/intl/multilang'
import { CategoryLabel } from 'apprise-frontend-tags/category/label'
import { useCategoryModel } from 'apprise-frontend-tags/category/model'
import { useReorderCategories } from 'apprise-frontend-tags/category/reorder'
import { noModule, tagType } from 'apprise-frontend-tags/constants'
import { useTagTypeFilter } from 'apprise-frontend-tags/tag/filter'
import { useTagModules } from 'apprise-frontend-tags/tag/modules'
import { useTagStore } from 'apprise-frontend-tags/tag/store'
import { Label } from 'apprise-ui/label/label'
import { SortSpec } from 'apprise-ui/table/sorting'
import { Table } from 'apprise-ui/table/table'
import { useTableUtils } from 'apprise-ui/table/utils'
import { NumberIcon } from 'apprise-ui/utils/icons'
import React, { useMemo } from 'react'
import { AiOutlineCheck } from 'react-icons/ai'
import { useCategoryRouting } from './routing'
import { useCategoryStore } from './store'



export const CategoryTable = () => {

    const t = useT()
    const l = useL()

    const cats = { ...useCategoryModel(), ...useCategoryStore(), ...useCategoryRouting() }
    const store = useTagStore()

    const modules = useTagModules()

    const unfilteredCategories = cats.allCategories()

    const filterContext = `${tagType}-categories`

    const { typeFilter, typeFiltered, selectedType } = useTagTypeFilter({  categories: unfilteredCategories, context: filterContext })

    const reorder = useReorderCategories(selectedType)

    const data = typeFiltered

    const initialSort: SortSpec[] = [{ key: 'type', mode: 'asc' }, { key: 'name', mode: 'asc' }]

    // eslint-disable-next-line
    const counts = useMemo(() => cats.allCategories().reduce((acc, next) => ({ ...acc, [next.id]: store.allTagsOfCategory(next.id).length ?? 0 }), {}), [data])

    const { compareStringsOf, compareNumbersOf, Column } = useTableUtils<TagCategory>()

    const allModules = modules.all()

    // eslint-disable-next-line
    const typemap = useMemo(() =>  utils().index(allModules).mappingBy(m=> m.type, m => t(m.singular)),[allModules])

    return <React.Fragment>

        <Table resizable name={filterContext} data={data} total={unfilteredCategories.length} context={`${tagType}-categories`} initialSort={initialSort}>

            <Table.Control>
                {reorder.button}
            </Table.Control>

            <Table.Filter name="type">
                {typeFilter}
            </Table.Filter>

            <Column pinned name="name" width={220} title={t("tag.name_col")} text={c => c.name} render={c => <CategoryLabel category={c} />} sort={cats.categoryComparator} />

            <Column width={250} styleFor={c => c.type === noModule.type ? {opacity:.5} : {}} defaultLayout name="type" filter="type" text={c => typemap[c.type]}  sort={compareStringsOf(c => t(c.type ?? ''))} title={t("tag.type_col")} render={c => typemap[c.type]} />

            <Column defaultLayout name="tags" width={80} sort={compareNumbersOf(c => counts[c.id])} title={t("tag.tags_col")} render={c => <Label mode='tag' icon={<NumberIcon />} title={counts[c.id]} />} />

            <Column name="card" width={130} title={t("tag.cardinality_col")} render={c => t(cardinalityLabels[cardinalityKeyOf(c.cardinality)])} />

            <Column name="field" width={70} title={t('tag.field_col')} render={c => c.properties.field?.enabled && <AiOutlineCheck color='green' />} />

            <Column defaultLayout name="desc" text={c => c.description} title={t("tag.description_col")} render={c => l(c.description)} />


        </Table>

        {reorder.drawer}


    </React.Fragment>
}
